import { render, staticRenderFns } from "./cargogroup.vue?vue&type=template&id=c8908f4a&scoped=true&"
import script from "./cargogroup.vue?vue&type=script&lang=js&"
export * from "./cargogroup.vue?vue&type=script&lang=js&"
import style0 from "./cargogroup.vue?vue&type=style&index=0&id=c8908f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8908f4a",
  null
  
)

export default component.exports